import React from 'react';
import { Link } from 'react-router-dom';

import '../App.css'; // Importa tu CSS personalizado

// Imágenes
import ImgCarcasaPartida from '../img/products/SistemaContraIncendiosNormalizados/CarcasaPartida/CarcsaPartida1.png';
import ImgSuccionFinal from '../img/products/SistemaContraIncendiosNormalizados/SuccionFinal/SuccionFinal1.png';
import ImgTurbinaEjeVertical from '../img/products/SistemaContraIncendiosNormalizados/TurbinaEjeVertical/TurbinaEjeVertical1.png';
import ImgVerticalEnLinea from '../img/products/SistemaContraIncendiosNormalizados/VerticalEnLinea/VerticalEnLinea1.png';

const sistemas = [
    { nombre: 'Carcasa Partida', ruta: '/carcasaPartida', img: ImgCarcasaPartida },
    { nombre: 'Succión Final', ruta: '/succionFinal', img: ImgSuccionFinal },
    { nombre: 'Turbina Eje Vertical', ruta: '/TurbinaEjeVertical', img: ImgTurbinaEjeVertical },
    { nombre: 'Vertical En Línea', ruta: '/verticalEnLinea', img: ImgVerticalEnLinea },
];

const SistemaContraIncendiosNormalizados = () => {
    return (
        <div className="container my-5">
            <h3 className="mb-4 text-center text-danger">Sistema Contra Incendios Normalizados</h3>

            {/* Caja animada con fondo semitransparente */}
            <div className="animated-box mb-4" role="region" aria-label="Información sobre sistema no normalizado">
                <p className="mb-0 text-justify text-white">
                    Sistemas contra incendio normalizados Diesel y eléctricos, evaluados y aprobados por organizaciones
                    reconocidas como: Underwriters Laboratories (UL) y Associated Factory Mutual Fire Insurance Companies
                    (FM approved). Cumplen con todos los requerimientos de la National Fire Protection Association
                    Pampleth No. 20 (NFPA-20), lo que garantiza su desempeño y seguridad en situaciones de emergencia.
                </p>
            </div>

            {/* Grid de imágenes con Bootstrap */}
            <div className="row row-cols-1 row-cols-md-4 gx-2 gy-3">
                {sistemas.map((sistema, index) => (
                    <div className="col" key={index}>
                        <div className="card h-100">
                            <Link to={sistema.ruta} className="text-decoration-none text-dark">
                                <img
                                    src={sistema.img}
                                    alt={sistema.nombre}
                                    className="card-img-top img-fixed-size"
                                />
                                <div className="card-body">
                                    <h5 className="card-title text-center">{sistema.nombre}</h5>
                                </div>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SistemaContraIncendiosNormalizados;
